export default "__VITE_ASSET__b9cc7383__"